import { SortDirection, VFlow } from 'bold-ui'
import { Form } from 'components/form'
import { PageContent } from 'components/layout/PageContent'
import React, { Dispatch, useMemo, useState } from 'react'
import { ExibirPorHistoricoAtendimentoFilterEnum } from 'types/enums'

import { AtendimentoFooter } from '../AtendimentoFooter'
import { createHistoricoCalculator } from './components/filtro-historico/calculator'
import HistoricoAtendimentoFilter from './components/filtro-historico/HistoricoAtendimentoFilter'
import HistoricoAtendimentoTable from './components/table/HistoricoAtendimentoTable'
import { HistoricoAtendimentoFilterFormModel } from './model/HistoricoAtendimentoModel'

interface AtendimentoHistoricoViewProps {
  atendimentoId: ID
  cidadaoId?: ID
  isAtendimentoOdonto?: boolean
  clearCache: Dispatch<void>
}

const filtersDefaultValue: Partial<HistoricoAtendimentoFilterFormModel> = {
  exibirPorDataAnterior: ExibirPorHistoricoAtendimentoFilterEnum.TODOS_ATENDIMENTOS,
}

export function HistoricoAtendimentoView(props: AtendimentoHistoricoViewProps) {
  const [sort, setSort] = useState<SortDirection>('')
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [totalPages] = useState(4)
  const [totalElements] = useState(36)
  const decorators = useMemo(() => [createHistoricoCalculator()], [])
  // TODO (Odilon): Usar os dados da consulta na tabela de accordions
  // const {
  //   data: { dadosHistorico },
  // } = useBuscaListagemHistoricoClinicoQuery({
  //   variables: {
  //     input: {
  //       cidadaoId: cidadaoId,
  //     },
  //   },
  // })

  return (
    <React.Fragment>
      <PageContent fluid type='filled'>
        <VFlow>
          <Form<HistoricoAtendimentoFilterFormModel>
            render={HistoricoAtendimentoFilter}
            initialValues={filtersDefaultValue}
            decorators={decorators}
            onSubmit={() => {}}
          />
          <HistoricoAtendimentoTable
            content={[1, 2, 3]}
            sort={sort}
            onSortChange={setSort}
            page={page}
            onPageChange={setPage}
            pageSize={pageSize}
            onSizeChange={setPageSize}
            totalPages={totalPages}
            totalElements={totalElements}
          />
        </VFlow>
      </PageContent>
      <AtendimentoFooter
        atendimentoId={props.atendimentoId}
        isAtendimentoOdonto={props.isAtendimentoOdonto}
        clearCache={props.clearCache}
      />
    </React.Fragment>
  )
}
